import { render, staticRenderFns } from "./LinhaHorizontal.vue?vue&type=template&id=352b7502&"
import script from "./LinhaHorizontal.vue?vue&type=script&lang=js&"
export * from "./LinhaHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./LinhaHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports